import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";
import { postImport } from "common/lib/importClient";

const api = new APIClient();

/**
 * Relations an LTA needs before it can be rendered. The backend applies this
 * same set by default, but the list view sends it explicitly so filters and
 * populate travel together in one query object.
 */
export const LTA_POPULATE = [
  "ltaType",
  "ltaService",
  "location",
  "contractor",
  "leadAgency",
  "agencies",
  "ltaDocuments",
  "updatedby",
];

export const LTA_DETAIL_POPULATE = [
  ...LTA_POPULATE,
  "createdby",
  "createdby.agency",
  "updatedby.agency",
  "leadAgency.mainLogo",
  "leadAgency.mainLogoLight",
  "contracts",
  "contracts.contractor",
  "contracts.agency",
  "contracts.contractType",
];

// LTAs
export const getLTAs = (params: any) => api.get(url.GET_LTAS, params);
export const getLTA = (id: any, params: any = {}) => {
  if (!params?.populate) params.populate = LTA_DETAIL_POPULATE;
  return api.get(url.GET_LTA + "/" + id, params);
};
export const addLTA = (data: any) => api.createAndUpload(url.ADD_LTA, data);
export const updateLTA = (id: any, data: any) =>
  api.updateAndUpload(url.UPDATE_LTA + "/" + id, data);
export const deleteLTA = (id: any) => api.delete(url.DELETE_LTA + "/" + id);
export const getLTASummary = (params: any) =>
  api.get(url.GET_LTA_SUMMARY, params);
export const exportLTAsToCSV = (params: any) =>
  api.get(url.EXPORT_LTAS_TO_CSV, params, { responseType: "blob" });
export const importLTA = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_LTA, data, accessToken, options);

// Agency LTAs
export const getAgencyLTAs = (params: any) =>
  api.get(url.GET_AGENCY_LTAS, params);
export const getAgencyLTA = (id: any, params: any = {}) => {
  if (!params?.populate) params.populate = LTA_DETAIL_POPULATE;
  return api.get(url.GET_AGENCY_LTA + "/" + id, params);
};
export const addAgencyLTA = (data: any) =>
  api.createAndUpload(url.ADD_AGENCY_LTA, data);
export const updateAgencyLTA = (id: any, data: any) =>
  api.updateAndUpload(url.UPDATE_AGENCY_LTA + "/" + id, data);
export const deleteAgencyLTA = (id: any) =>
  api.delete(url.DELETE_AGENCY_LTA + "/" + id);
export const getAgencyLTASummary = (params: any) =>
  api.get(url.GET_AGENCY_LTA_SUMMARY, params);
export const exportAgencyLTAsToCSV = (params: any) =>
  api.get(url.EXPORT_AGENCY_LTAS_TO_CSV, params, { responseType: "blob" });
export const importAgencyLTA = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_AGENCY_LTA, data, accessToken, options);

// LTA Types
export const getLTATypes = (params: any) => api.get(url.GET_LTA_TYPES, params);
export const getLTAType = (id: any, params: any) =>
  api.get(url.GET_LTA_TYPE + "/" + id, params);
export const addLTAType = (data: any) => api.create(url.ADD_LTA_TYPE, data);
export const updateLTAType = (id: any, data: any) =>
  api.put(url.UPDATE_LTA_TYPE + "/" + id, data);
export const deleteLTAType = (id: any) =>
  api.delete(url.DELETE_LTA_TYPE + "/" + id);
export const exportLTATypesToCSV = (params: any) =>
  api.get(url.EXPORT_LTA_TYPES_TO_CSV, params, { responseType: "blob" });
export const importLTAType = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_LTA_TYPE, data, accessToken, options);

// LTA Services
export const getLTAServices = (params: any) =>
  api.get(url.GET_LTA_SERVICES, params);
export const getLTAService = (id: any, params: any) =>
  api.get(url.GET_LTA_SERVICE + "/" + id, params);
export const addLTAService = (data: any) =>
  api.create(url.ADD_LTA_SERVICE, data);
export const updateLTAService = (id: any, data: any) =>
  api.put(url.UPDATE_LTA_SERVICE + "/" + id, data);
export const deleteLTAService = (id: any) =>
  api.delete(url.DELETE_LTA_SERVICE + "/" + id);
export const exportLTAServicesToCSV = (params: any) =>
  api.get(url.EXPORT_LTA_SERVICES_TO_CSV, params, { responseType: "blob" });
export const importLTAService = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_LTA_SERVICE, data, accessToken, options);
